<template>
  <b-row>
    <b-col cols="12">
      <router-link :to="{ name: 'EXABSurveysList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
    </b-col>
    <b-col cols="12">
      <b-card>
        <Form
          @submit="onSendForm($event)"
          :values="item"
          :violations="violations"/>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Form from './Form'
import { checkPagePermission } from '@/utils/checkRoles'

export default {
  name: 'Create',
  components: {
    Form
  },
  data () {
    return {
      item: {
        surveyTitle: '',
        surveyDescription: '',
        sendEmailAfter: 1,
        mailToOwner: 1,
        mailToOffice: 1,
        customEmail: 1,
        customEmailContent: '',
        signAgreement: 0,
        agreementItemServiceStatus: 0,
        form: {
          surveyGroupsQuestions: []
        }
      }
    }
  },
  watch: {
    created (val) {
      if (val && this.$route.name === 'EXABSurveysCreate') {
        this.$router.push({ name: 'EXABSurveysList' })
      }
    }
  },
  beforeCreate () {
    checkPagePermission('exabagreements', 'EXABSurveysCreate')
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapGetters({
      created: 'surveys/create/created',
      violations: 'surveys/create/violations',
      isLoading: 'surveys/create/isLoading'
    })
  },
  methods: {
    onSendForm (item) {
      this.create(item)
    },
    ...mapActions({
      create: 'surveys/create/create',
      reset: 'surveys/create/reset'
    })
  }
}
</script>

<style scoped>

</style>
